import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PageHeader, { useStyles } from '../../components/PageHeader';

const UserListHeader = () => {
  const classes = useStyles();

  return (
    <PageHeader
      title="Users"
      actionButtons={
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          component={Link}
          to="/add-user"
        >
          Add New User
        </Button>
      }
    />
  );
};

export default UserListHeader;
